<div class="password-strength">
  <div class="password-strength__header">
    <span>Password Strength</span>
    <span *ngIf="passwordStrength"
      ><strong>{{ passwordStrength }}</strong></span
    >
  </div>
  <div class="password-strength__progress-container">
    <div
      class="password-strength__progress-bar"
      [ngClass]="{
        'password-strength__progress-bar-poor': passwordStrength === strengths.Poor,
        'password-strength__progress-bar-medium': passwordStrength === strengths.Medium,
        'password-strength__progress-bar-good': passwordStrength === strengths.Good
      }"
    ></div>
  </div>
</div>
